"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.transformAccount = exports.transformOrders = void 0;

var _util = require("lodash/util");

var _lang = require("lodash/lang");

var _array = require("lodash/array");

var _i18next = _interopRequireDefault(require("i18next"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var isNullToEmptyString = function isNullToEmptyString(value) {
  return (0, _lang.isEmpty)(value) ? (0, _util.stubString)() : value;
};

var transformProductImage = function transformProductImage(media, size) {
  var image = (0, _array.head)(media);
  return "".concat(image.path, "/").concat(image.file, "_").concat(size, ".").concat(image.ext);
};

var transformStatus = function transformStatus(status) {
  switch (status) {
    case 0:
    case 5:
    case 10:
      return 'open';

    case 15:
    case 17:
    case 20:
    case 25:
    case 30:
    case 35:
      return 'preparing';

    case 40:
      return 'inDelivery';

    case 42:
      return 'withIncidence';

    case 45:
      return 'delivered';

    case 50:
      return 'canceled';

    default:
      return 'unknown';
  }
};

var transformCreditCards = function transformCreditCards(cardList) {
  return cardList.map(function (card) {
    return {
      id: card.id,
      type: card.type,
      number: card.number,
      expirationMonth: card.exp_month,
      expirationYear: card.exp_year,
      holder: card.cardholder_name
    };
  });
};

var transformAddresses = function transformAddresses(addressList) {
  return addressList.map(function (address) {
    return {
      alias: address.alias,
      city: address.city,
      company: address.company,
      country: address.country,
      details: address.details,
      hasInvoice: address.invoice_person_type !== null,
      id: address.id,
      invoiceEmail: isNullToEmptyString(address.invoice_email),
      invoiceFirstSurname: isNullToEmptyString(address.invoice_first_surname),
      invoiceName: isNullToEmptyString(address.invoice_name),
      invoicePersonType: isNullToEmptyString(address.invoice_person_type),
      invoiceSecondSurname: isNullToEmptyString(address.invoice_second_surname),
      lift: address.lift === '0' ? 'no' : 'yes',
      name: address.name,
      nif: address.nif,
      number: address.number,
      phone: address.phone,
      postalCode: address.postal_code,
      street: address.street
    };
  });
};

var transformOrders = function transformOrders(orders) {
  return orders.map(function (order) {
    return {
      address: order.attributes.address,
      canRefund: order.attributes.can_refund,
      date: order.attributes.delivery_date,
      id: order.id,
      invoiceURL: order.attributes.invoice,
      total: Number.parseFloat(order.attributes.total).toLocaleString('es-ES', {
        style: 'currency',
        currency: 'EUR'
      }),
      totalProducts: Number.parseFloat(order.attributes.total_products).toLocaleString('es-ES', {
        style: 'currency',
        currency: 'EUR'
      }),
      totalShipment: Number.parseFloat(order.attributes.total_shipment).toLocaleString('es-ES', {
        style: 'currency',
        currency: 'EUR'
      }),
      products: order.attributes.products.map(function (product) {
        return {
          name: product.name,
          price: Number.parseFloat(product.price).toLocaleString('es-ES', {
            style: 'currency',
            currency: 'EUR'
          }),
          quantity: product.quantity,
          medias: {
            small: transformProductImage(product.medias.image, 'small'),
            large: transformProductImage(product.medias.image, 'large'),
            xl: transformProductImage(product.medias.image, 'xl')
          }
        };
      }),
      totalDiscounts: order.attributes.total_discounts,
      status: transformStatus(order.attributes.status)
    };
  });
};

exports.transformOrders = transformOrders;

var transformAccount = function transformAccount(_ref) {
  var id = _ref.id,
      attributes = _ref.attributes;
  return {
    id: id,
    email: attributes.email,
    firstName: attributes.first_name,
    lastName: attributes.last_name,
    newsletterSubscription: attributes.newsletter_subscription,
    postalCode: attributes.postal_code,
    language: attributes.language,
    sex: attributes.sex,
    creditCards: transformCreditCards(attributes.credit_cards),
    addresses: transformAddresses(attributes.addresses)
  };
};

exports.transformAccount = transformAccount;
var _default = {
  id: (0, _util.stubString)(),
  email: (0, _util.stubString)(),
  firstName: (0, _util.stubString)(),
  lastName: (0, _util.stubString)(),
  newsletterSubscription: false,
  postalCode: (0, _util.stubString)(),
  sex: (0, _util.stubString)(),
  creditCards: [],
  addresses: [],
  language: (0, _util.defaultTo)(_i18next.default.language, 'es'),
  orders: []
};
exports.default = _default;